import { useLayoutEffect } from 'react'
import { v4 } from 'uuid'
import { useModelMeshStore } from '../state/store'

const useModelSelectionV2 = (selectedGuids: string[], stateId?: string) => {
  const addSelectedGuids = useModelMeshStore(state => state.addSelectedGuids)
  const removeSelectedGuids = useModelMeshStore(state => state.removeSelectedGuids)

  useLayoutEffect(() => {
    const uuid = stateId || v4()

    if (selectedGuids.length) {
      addSelectedGuids(uuid, selectedGuids)
    }

    return () => removeSelectedGuids(uuid)
  }, [addSelectedGuids, selectedGuids, removeSelectedGuids, stateId])
}

export default useModelSelectionV2
